import { Component, OnInit } from '@angular/core';
import { HelperService } from "@app/core";

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    standalone: false
})
export class ContactUsComponent implements OnInit {

  constructor(private helperService : HelperService) { }

  ngOnInit(): void {
  }
}
